import { TThunkAction } from '../../types/redux';
import { requestVacancies, requestVacanciesError, setVacanciesGroups } from './actions';
import {
  fetchGetVacancies,
  IGetVacanciesResponse200,
  IGetVacanciesResponse400,
} from '../../common/repositories/job-vacancies-backend/v2/get-vacancies';

export const fetchVacancies = (): TThunkAction => async (dispatch, getState, context) => {
  const { httpApi, logger } = context;
  const {
    vacancies: { selectedFilters = {} },
  } = getState();

  dispatch(requestVacancies());

  try {
    const result = await fetchGetVacancies<IGetVacanciesResponse200, IGetVacanciesResponse400>({
      httpApi,
      parameters: {
        filters: { ...selectedFilters },
      },
    });

    if (result.statusCode === 200) {
      dispatch(setVacanciesGroups(result.response.groups));

      return;
    }

    dispatch(requestVacanciesError());
  } catch (e) {
    dispatch(requestVacanciesError());
    logger.error(e, { domain: 'fetchVacancies' });
  }
};
